// extracted by mini-css-extract-plugin
module.exports = {"UsernameForm":"UsernamePasswordForm_UsernameForm__3UW3A","Input":"UsernamePasswordForm_Input__1UJXx","Heading":"UsernamePasswordForm_Heading__2nfLH"};